/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { CustomersHorizontalNav } from './ui/index.tsx';

const LazyCustomersNav = lazyForPaint<typeof CustomersHorizontalNav>(
	() =>
		import(/* webpackChunkName: "async-horizontal-nav-csm-customers-nav" */ './ui/index.tsx').then(
			({ CustomersHorizontalNav }) => CustomersHorizontalNav,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncCustomersNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-csm-customers-nav" fallback={null}>
		<LazyCustomersNav />
	</Placeholder>
);
